<template>
  <div class="list-of-boards-wrap project-preview">
    <vue-scroll
      ref="projectPreviewScroll"
      :ops="{
        scrollPanel: { scrollingX: false },
        rail: { gutterOfSide: '5px' },
        bar: { keepShow: true },
      }"
      @handle-scroll="scrollHandler"
    >
      <div class="project-preview__preview-project-board-list-wrap">
        <PreviewSpaceBoards
          :boards-ids="previewProjectBoards"
          :project-id="previewProjectId"
        />
      </div>
    </vue-scroll>
  </div>
</template>

<script>
import PreviewSpaceBoards from './PreviewSpaceBoards.vue';
import EventBus from '@/utilities/eventBus';

export default {
  name: 'PreviewSpace',
  components: {
    PreviewSpaceBoards,
  },

  data() {
    return {
      currentScrollPosition: 0,
    };
  },

  computed: {
    draggingBoard() {
      return this.$store.getters.draggedEntity.entityName === 'board';
    },
    previewProjectId() {
      return this.$store.getters.previewProject.id;
    },

    previewProjectBoards() {
      return this.$store.getters.projectPreviewBoards[this.previewProjectId] || [];
    },
  },

  watch: {
    previewProjectId(newValue) {
      if (newValue) {
        this.scrollToTop();
      }
    },
  },

  mounted() {
    EventBus.$on('saveLastScrollPosition', this.saveScrollPosition);
  },

  unmounted() {
    EventBus.$off('saveLastScrollPosition', this.saveScrollPosition);
  },

  methods: {
    scrollHandler() {
      this.currentScrollPosition = this.$refs.projectPreviewScroll.getPosition().scrollTop;
    },
    saveScrollPosition() {
      this.$store.dispatch('setProjectPreviewLastScrollPos', {
        projectId: this.previewProjectId,
        scrollPosition: this.currentScrollPosition,
      });
    },
    scrollToTop() {
      this.$refs.projectPreviewScroll?.scrollTo(
        {
          y: '0%',
        },
        0
      );
    },
  },
};
</script>

<style lang="scss">
.project-preview {
  @apply bg-background-strongest absolute z-10;
  height: calc(100vh - $headerHeight);

  > .__vuescroll > .__panel > .__view {
    @apply pt-2 pb-16 h-full;

    .project-preview__preview-project-board-list-wrap {
      @apply h-full;

      .preview-project-board-list {
        @apply h-full;

        .list-of-boards {
          @apply h-full;
          padding: 0;
        }

        .draggable-board-list {
          @apply h-full;
          padding: $spaceHomePagePadding;
        }
      }
    }
  }
}
</style>
